import { OnInit, Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

    @Input() messages: string[];
    @Input() type: string;
    @Output() closeMessage = new EventEmitter();
    
    ngOnInit(): void {
        //Empty ngOnInit()
    }

    onClick() {
        this.closeMessage.emit();
    }

}

export enum MessageType {
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error'
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/message/message.component.ts